import React from "react";
import './PrimaryButton.css'




export default function PrimaryButton({title,func,textColor,bgColor,icon,marginL=0, marginR=0}){

    return(
        <div className="primarybutton__container">
      <button className="primarybutton__btn shinebutton" style={{backgroundColor:bgColor,marginLeft:marginL,marginRight:marginR}} onClick={func}>
        <img src={icon}></img> <p style={{color:textColor}}>{title}</p>
      </button>
        </div>
    )
}